// Module
var code = "<tr>\n    <td data-bind=\"text: mcrDisplay\"></td>\n    <!-- ko foreach: results -->\n\n    <!-- ko component: { name: 'benefit-consequence-result', params: { result: $data, diagnosticTypeName: $component.diagnosticTypeName, \n        hasSFRBenchmarkingError: $component.hasSFRBenchmarkingError } } --><!-- /ko -->\n\n    <!-- /ko -->\n</tr>";
// Exports
module.exports = code;